<div class="notification-tile">
    <div class="pull-right">
        <a (click)="goToAllNotifications()" class="all-notifications">{{"AllNotifications" | localize}}</a>
    </div>
    <h5>{{ l("RecentNotifications") }}</h5>
    <div class="notification-row" *ngFor="let notification of notifications">
        <div class="notification-icon">
            <span class="icon"><i class="{{notification.icon}} {{notification.iconFontClass}}"></i></span>
        </div>
        <div class="notification-text">
            <a (click)="gotoUrl(notification.url)" [ngClass]="{'user-notification-item-clickable': notification.url}">
                {{notification.text}}
            </a>
        </div>
        <div class="notification-time">
            {{notification.time | momentFromNow}}
        </div>
        <div class="notification-remove material-icons" (click)="removeRecentNotification(notification)">close</div>
    </div>
    <span *ngIf="!notifications.length" class="notification-empty-text">
        {{l("ThereAreNoNotifications")}}
    </span>
</div>
